import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from 'services/authentication/AuthenticationContext';
import { encryptData } from 'services/authentication/encryptData';
import TwoFactorEnrollment from './TwoFactorEnrollment';
import SecondaryButton from 'components/buttons/SecondaryButton';
import logoGrey from 'assets/crafter-logo-grey.png';
import '../../style/scss/account.scss';

// Full screen page that forces the user to set up two factor authentication
const TwoFactorSetupPage: React.FC = () => {
    const { t } = useTranslation();
    const { setRedirectTo, handleLogout } = useAuthContext();
    const history = useHistory();

    // Leave the setup screen after a successful enrollment
    const onEnrollmentSuccess = (redirectTo: string | null) => {
        const redirect = redirectTo || 'dashboard';

        // Update the redirect state and the encrypted local storage
        setRedirectTo(redirect);
        localStorage.setItem('redirect_to', encryptData(JSON.stringify(redirect)));

        // Redirect to the target page
        history.push(`/${redirect}`);
    };

    return (
        <div className='container-center'>
            <div className='account-container'>
                <img src={logoGrey} alt="Logo" className='account-logo'/>
                <div className='account-form two-factor-setup'>
                    <h4>{t('account.two_factor_setup_title')}</h4>
                    <TwoFactorEnrollment onSuccess={onEnrollmentSuccess} />
                </div>
                <div className='account-buttons'>
                    <SecondaryButton
                        label="account.logout_button_label"
                        size="small"
                        onClick={() => handleLogout({ logoutFromServer: true })} />
                </div>
            </div>
        </div>
    );
};

export default TwoFactorSetupPage;
